export const tourGuideSteps = [
  {
    selector: "#entitlement-header-1",
    content:
      "This area provides a brief summary of the client and environment details.",
  },
  {
    selector: "#entitlement-header-2",
    content:
      "This area provides a brief summary of the allotment and the number of entitlements being used. The number of used entitlements cannot exceed the allotment.",
  },
  {
    selector: "#entitlement-data-grid-buttons",
    content:
      "These buttons allow the user to globally (un)select the channels for entitlement usage.",
  },
  {
    selector: "#reporting-enabled-column",
    content:
      "This is the column checkbox to select or unselect channels to use the reporting entitlement.",
  },
  {
    selector: "#archiving-enabled-column",
    content:
      "This is the column checkbox to select or unselect channels to use the archiving entitlement.",
  },
];
